<template>
  <div>
    <div class="table-responsive">
      <div
        id="zero_config_wrapper"
        class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
      >
        <div class="row" style="height: 15rem; overflow: auto">
          <div class="col-sm-12">
            <table id="zero_config" class="table">
              <thead class="data-table-bg">
                <tr>
                  <th
                    :key="index"
                    v-for="(column, index) in tableColumns"
                    style="cursor: pointer; text-align: center"
                  >
                    {{ column[0] }}
                  </th>
                </tr>
              </thead>
              <tbody v-if="containers.length">
                <template>
                  <tr
                    :key="index"
                    v-for="(data, index) in containers"
                    style="cursor: pointer; text-align: center"
                    :class="{ 'data-table-bg': index % 2 !== 0 }"
                  >
                    <td style="text-transform: capitalize;">
                      {{ data.product }}
                    </td>
                    <td>{{ data.pallet }}</td>
                    <td>{{ data.containerNumber }}</td>
                    <td>
                      {{ data.assignedDevices.length }} {{
                        data.assignedDevices.length > 1 ? "Devices" : "Device"
                      }}
                    </td>
                    <td>
                      <div class="actions">
                        <span
                          class="cursor-pointer"
                          @click="$emit('edit_container', data, index)"
                        >
                          <IconEdit />
                        </span>
                        <span
                          class="cursor-pointer"
                          @click="$emit('delete_container', index)"
                        >
                          <IconDeleteUser />
                        </span>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6">
                    <div
                      class="d-flex justify-content-center align-items-center"
                      style="height: 8rem"
                    >
                      <div
                        class="cursor-pointer d-flex justify-content-center align-items-center"
                        @click="$emit('showAddContainerModal')"
                      >
                        <icon-circle-add class="mr-2" />
                        <span class="text-primary">{{
                          $t("add_container")
                        }}</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconCircleAdd from "../../../components/Iconsvg/IconCircleAdd.vue";
import IconDeleteUser from "../../../components/Iconsvg/IconDeleteUser.vue";
import IconEdit from "../../../components/Iconsvg/IconEditUser.vue";

export default {
  components: { IconCircleAdd, IconDeleteUser, IconEdit },
  name: "ContainerDetails",
  props: {
    containers: Array,
  },
  computed: {
    tableColumns() {
      return [
        [this.$t("product"), "column1"],
        [this.$t("No of Pallet "), "column2"],
        [this.$t("Container Number"), "column3"],
        [this.$t("Device"), "column4"],
        [this.$t("Actions"), "column5"],
      ];
    },
  },

  mounted() {
    console.log(this.containers);
  },
};
</script>

<style scoped>
.actions {
  display: flex;
  gap: 1rem;
  justify-content: center;
}
</style>
